import React from "react";

import SubscriptionFormModal from "./SubscriptionFormModal";

export default function EditSubscriptionModal(
  props,
) {
  return (
    <SubscriptionFormModal
      {...props}
      mode="edit"
    />
  );
}